<script>
import Base from '@backend/Base.vue';
import BOGen from '@helper/BOGen';
import BoConfig from '@config/BoConfig';

export default {
  extends: Base,
  data(){
    return {
      Name:"AccessLevel",
      PageName: "Access Level List",
      ObjectName: "Access Level",
      AddItem: true,
      WithLimit: true,
      mrValidation: {
        al_name: "required|minlength:3",
      },
      emp: {}
    }
  },
  computed:{
    mrAccessMenu(){ 
      let masterAccess = this.BoConfig.mrAccessMenu
      return masterAccess
    },
    mrAccessModule(){ return BoConfig.mrAccessModule },
  },
  mounted(){
    this.filter.limit = 50;
    this.$set(this.$root, 'page', this)
    this.refreshData()
  },
  methods: {
    setOverflowAuto(){
      document.querySelector('.page-wrapper').style.overflow = 'auto'
    },
    setOverflowHidden(){
      document.querySelector('.page-wrapper').style.overflow = 'hidden'
    },
    postForm(){
      let indexA = this.row.al_access_menu.findIndex(x=>x == 'Dashboard')
      if(indexA == -1){
        this.row.al_access_menu.unshift("Dashboard")
      }
      // dashboard
      this.submitForm()
    },
  },
  watch:{
    '$route.query'(v){
      this.refreshData()
    }
  }
}
</script>

<template>
  <div class="container-fluid">
    <PageTitle></PageTitle>
    
    <!-- ======================================================================== 
      LIST DATA
    ============================================================================= -->
    <div class="card card-flat" v-if="!$route.params.id">
      <div class="card-body card-filter">
        <VForm @resp="search">
          <div class="row">
            <div class="col-sm-3">
              <h4 class="card-title">{{ObjectName}} List <span v-if="data.total">({{(data.total||0).format()}})</span></h4>
            </div>
            <div class="col-sm-3"></div>
            <div class="col-sm-2">
              <Select2 :options="BoConfig.mrPageLimit" v-model="filter.limit" @input="changeLimit"></Select2>
            </div>
            <div class="col-sm-3">
              <div class="has-feedback has-feedback-left">
                <input type="search" v-model="filter.search" class="form-control" placeholder="Type and hit Enter">
                <div class="form-control-feedback">
                  <i class="icon-search4 text-size-base text-muted"></i>
                </div>
              </div>
            </div>
            <div class="col-sm-1">
              <button type="button" @click="resetSearch()" class="btn btn-warning btn-sm">Reset</button>
            </div>
          </div>
        </VForm>
      </div>
      <div class="table-responsive ajax-table">
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th width="50px">#</th>
              <th><SortField name="level" :label="fields.al_name"></SortField></th>
              <th width="120px">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(v,k) in data.data" :key="k">
              <td class="number">{{(data.per_page*(data.current_page-1))+k+1}}</td>
              <td>{{v.al_name}}</td>
              <td class="btn-action">
                <router-link class="icon_action" :to="{name:Name,params:{id:v.id}}" v-tooltip="'Edit'"><i class="icon-pencil"></i></router-link>
                <a href="javascript:;" class="icon_action" @click="deleteItem($event,k)" v-tooltip="'Remove'"><i class="icon-trash"></i></a>
              </td>
            </tr>
            <tr v-if="NotFound">
              <td colspan="99">
                <h3 class="tc">{{NotFound}}</h3>
              </td>
            </tr>
            <tr v-if="data.data===false">
              <td colspan="99">
                <LoadingSpinner light></LoadingSpinner>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-body">
        <div class="pull-right">
          <Pagination :data="data" :limit="3" @pagination-change-page="onPaging"></Pagination>
        </div>
      </div>
    </div>

    <!-- ======================================================================== 
      FORM CRUD
    ============================================================================= -->
    <div class="card card-flat" v-if="$route.params.id">
      <VForm @resp="postForm" method="post">
        <div class="card-body card-form">
          <h4 class="card-title">{{(row.id?"Edit":"Add")+" "+ObjectName}}</h4>
        </div>
        <div class="card-body">
          <div class="info"></div>
          <div class="row">
            <div class="col-sm-6">
              <BoField name="al_name" v-model="row.al_name"></BoField>
              <BoField name="al_access_menu">
                <Select2 name="al_access_menu" :options="mrAccessMenu" 
                v-model="row.al_access_menu" :value="row.al_access_menu" multiple></Select2>
              </BoField>
              <small class="text-info">
                note: The Dashboard menu is automatically assigned
              </small>
            </div>

            <div class="col-sm-6">
              <BoField name="al_access_module">
                <Select2 name="al_access_module" :options="mrAccessModule"  v-model="row.al_access_module" multiple></Select2>
                <small class="text-info">*For employee level, you don't need to select access module</small>
              </BoField>
            </div>

            <div class="col-sm-12">
              <div class="text-right">
                <button type="button" @click="back()" class="btn btn-default mr5">Cancel</button>
                <button type="submit" class="fcbtn btn btn-info btn-outline btn-1e btn-loading">Submit form <i class="icon-arrow-right14 position-right"></i></button>
              </div>
            </div>
          </div>
        </div>
      </VForm>
    </div>
  </div>
</template>
